export const ArrowPosition = {
    LEFT: 'left',
    RIGHT: 'right',
    TOP: 'top',
}



// WEBPACK FOOTER //
// ./components/TutorialArrow/constants.js